export default {"src":"/_next/static/media/niqs.e7a30639.svg","height":52,"width":160};